/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskGlassdoorOverview } from './ExecRiskGlassdoorOverview';
import {
    ExecRiskGlassdoorOverviewFromJSON,
    ExecRiskGlassdoorOverviewFromJSONTyped,
    ExecRiskGlassdoorOverviewToJSON,
} from './ExecRiskGlassdoorOverview';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedGlassDoorScanResponse
 */
export interface ExecRiskPaginatedGlassDoorScanResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGlassDoorScanResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskGlassdoorOverview>}
     * @memberof ExecRiskPaginatedGlassDoorScanResponse
     */
    results: Array<ExecRiskGlassdoorOverview>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedGlassDoorScanResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGlassDoorScanResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedGlassDoorScanResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedGlassDoorScanResponse interface.
 */
export function instanceOfExecRiskPaginatedGlassDoorScanResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedGlassDoorScanResponseFromJSON(json: any): ExecRiskPaginatedGlassDoorScanResponse {
    return ExecRiskPaginatedGlassDoorScanResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedGlassDoorScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedGlassDoorScanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskGlassdoorOverviewFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedGlassDoorScanResponseToJSON(value?: ExecRiskPaginatedGlassDoorScanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskGlassdoorOverviewToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

